import manifest from './canned-clips.json';

/** Cue played or shown just before a clip's line: a sound or a scene effect. */
export type ClipCue = 'owl' | 'raven' | 'squeak' | 'butterfly' | 'explosion';

export type CannedClip = {
  id: string;
  /** The spoken line, shown as the portrait caption while the clip plays. */
  text: string;
  cue: ClipCue | null;
  /** Optional generated full-body motion asset; facial clips use the default path. */
  asset?: string;
  /** Optional intermediate Ditto render target used before final assembly. */
  renderAsset?: string;
  /** Fixed Ditto source id used by the offline clip generator. */
  portraitSourceId?: string;
  /** Optional offline-render timing for motion staged before or after speech. */
  leadSilenceMs?: number;
  tailSilenceMs?: number;
  /** Whether this clip can be selected by the automatic idle cycle. */
  random?: boolean;
  /** After this clip Mara leaves the frame for a moment. */
  exit?: boolean;
};

export const CANNED_CLIPS: readonly CannedClip[] = manifest.clips as CannedClip[];

export function cannedClipUrl(clip: Pick<CannedClip, 'id' | 'asset'>): string {
  return clip.asset ?? `/assets/clips/mara-${clip.id}.mp4`;
}
